<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <!-- ngx-datatable-filter -->
						 <div >
							 <div class="row" (resized)="onResized($event)">
								 <div *ngIf="month_totalAmount" class="report-card col-xl-2 col-lg-6 col-md-6">
									 <div class="card bg-lighten-3 bg-success">
										 <div class="card-content">
											 <div class="card-body py-0">
												 <div class="media">
													 <div class="media-body text-left text-success">
														 <h3 class="font-large-1 mb-0 text-success">{{month_totalAmount |currency:'USD':'symbol':'1.0-0'}}</h3>
														 <span>This Month</span>
													 </div>
												 </div>
											 </div>
										 </div>
									 </div>
								</div>
								<div *ngIf="last_month_totalAmount" class="report-card col-xl-2 col-lg-6 col-md-6">
									<div class="card bg-lighten-3 bg-info">
										<div class="card-content">
											<div class="card-body py-0">
												<div class="media">
													<div class="media-body text-left text-info">
														<h3 class="font-large-1 mb-0 text-info">{{last_month_totalAmount |currency:'USD':'symbol':'1.0-0'}}</h3>
														<span>Last Month</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div *ngIf="week_totalAmount" class="report-card col-xl-2 col-lg-6 col-md-6">
									<div class="card bg-lighten-3 bg-primary">
										<div class="card-content">
											<div class="card-body py-0">
												<div class="media">
													<div class="media-body text-left text-primary">
														<h3 class="font-large-1 mb-0 text-primary">{{week_totalAmount | currency:'USD':'symbol':'1.0-0'}}</h3>
														<span>This Week</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div *ngIf="previous_week_totalAmount" class="report-card col-xl-2 col-lg-6 col-md-6">
									<div class="card bg-lighten-3 bg-warning">
										<div class="card-content">
											<div class="card-body py-0">
												<div class="media">
													<div class="media-body text-left text-warning">
														<h3 class="font-large-1 mb-0 text-warning">{{previous_week_totalAmount | currency:'USD':'symbol':'1.0-0'}}</h3>
														<span>Last Week</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- <div class="report-card col-xl-2 col-lg-6 col-md-6">
									<div class="card bg-lighten-3 bg-danger">
										<div class="card-content">
											<div class="card-body py-0">
												<div class="media">
													<div class="media-body text-left text-danger">
														<h3 class="font-large-1 mb-0 text-danger"></h3>
														<span>Total Due</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> -->
								<div *ngIf="current_total_amount" class="report-card col-xl-2 col-lg-6 col-md-6">
									<div class="card bg-lighten-3 bg-danger">
										<div class="card-content">
											<div class="card-body py-0">
												<div class="media">
													<div class="media-body text-left text-danger">
														<h3 class="font-large-1 mb-0 text-danger">{{current_total_amount | currency:'USD':'symbol':'1.0-0'}}</h3>
														<span>Current Total</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							 </div>

						 </div>
                        <fieldset class="form-group">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">

                                    <!-- <div class="btn-group enrollment-list-btn-info" role="group">
                                        <button class="btn enrollment-list-buttons cursor-pointer" type="button" *ngFor="let status of type_List"
                                            [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                                            (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                                    </div> -->
									<div class="d-flex"> 
										<div>
											<input type="date" class="form-control width-150" (change)="getStartDate($event)" [(ngModel)]="startDate"
												[ngModel]="startDate | date: 'yyyy-MM-dd'" [disabled]="false" id="last_activedate"
												placeholder="Enter last active date" />
										</div>
										<h6 style="align-items: center;
														  display: flex; margin: 4px;">To</h6>
										<div>
											<input type="date" class="form-control width-150" (change)="getEndDate($event)" [(ngModel)]="endDate"
												[ngModel]="endDate | date: 'yyyy-MM-dd'" [disabled]="false" id="last_activedate"
												placeholder="Enter last active date" />
										</div>
										<!-- <div>
											<button class="btn btn-primary btn-block glow mx-1" (click)="getReportsList()">{{ isHourlyList ? 'Fixed' : 'Hourly' }}</button>
										</div> -->

									</div>

                                </div>
								<div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
									<div class="row-flex">
									  <div class="col-flex-2 mb-1 position-relative">
										<input id="ngx-filter-ref"
										  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
										  type="text"  placeholder="search by name" #name [(ngModel)]="searchVal" (keydown.enter)="searchFilter(searchVal)"/>
										<button class="btn search-btn glow position-absolute" (click)="searchFilter(searchVal)">
										  <i class="ft-search text-white cursor-pointer"></i>
										</button>
									  </div>
									  <div class="col-flex-2 mb-1" (click)="resetFilter()">
										<button class="btn btn-primary btn-block users-list-clear glow mb-0">Reset
										  <i class="ft-filter text-white cursor-pointer"></i>
										</button>
									  </div>
									  <!-- <div class="col-flex-2 mb-1"
										*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
										<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
										 placement="top" ngbTooltip="Add New" (click)="openAddModal(myModalPayment)">
										  +
										</button>
									  </div> -->
									<div ngbDropdown class="d-inline-block mb-1">
										<button class="btn btn-primary btn-block glow mb-0" placement="top" ngbTooltip="Add New" ngbDropdownToggle>
											+
										</button>
										<div ngbDropdownMenu>
											<button ngbDropdownItem (click)="openAddModal(myModalPayment,'add hourly','add new')">Hourly</button>
											<button ngbDropdownItem (click)="openAddModal(myModalPayment,'add fixed','add new')">Fixed</button>
										</div>
									</div>
									</div>
								  </div>
								  <div class="col-12 my-1">
									<div class="d-flex ">
									<button class="btn btn-outline-primary" [ngClass]="{'btn-primary':activeFilter=='this week','btn-outline-primary':activeFilter!='this week'}" (click)="filterDate('this week')">This Week</button>
									<button class="btn btn-outline-primary" [ngClass]="{'btn-primary':activeFilter=='last week','btn-outline-primary':activeFilter!='last week'}" (click)="filterDate('last week')">Last Week</button>
									<button class="btn btn-outline-primary" [ngClass]="{'btn-primary':activeFilter=='this month','btn-outline-primary':activeFilter!='this month'}" (click)="filterDate('this month')">This
										Month</button>
									<button class="btn btn-outline-primary"
										[ngClass]="{'btn-primary':activeFilter=='last month','btn-outline-primary':activeFilter!='last month'}"
										(click)="filterDate('last month')">Last
										Month</button>
									
									<div>
										<ng-select [items]="usersList" class="filter-container mx-1" bindLabel="name" bindValue="_id" placeholder="Select Farming"
											[(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }" (change)="getFarmId($event,'filter')"
											#farmingBy="ngModel">
										</ng-select>
									</div>
									<div>
										<ng-select [items]="channels_list" class="filter-container mx-1" bindLabel="name" bindValue="_id" placeholder="Select Channel"
											[(ngModel)]="selectedChannel" [ngModelOptions]="{ standalone: true }" (change)="getChannelId($event)"
											#channel="ngModel">
										</ng-select>
									</div>
									<div>
										<ng-select [items]="type_list" class="filter-container mx-1" bindLabel="name" 
											placeholder="Select Type" [(ngModel)]="selected_filter_type" [ngModelOptions]="{ standalone: true }"
											(change)="getFilterTypeId($event)" #type="ngModel">
										</ng-select>
									</div>
									</div>
									<!-- <div class="my-1" *ngIf="isHourlyList ===false">
										<b><span>Total Limit: {{final_totals?.total_limits}}</span> &nbsp;&nbsp;
										<span>Total Hours: {{final_totals?.total_hours}}</span> &nbsp;&nbsp;
										<span>Completed Hours: {{final_totals?.complete_hours}}</span> &nbsp;&nbsp;
										<span>Pending Hours: {{final_totals?.pendingHours}}</span></b>
									</div>
									<div class="my-1" *ngIf="isHourlyList ===true">
										<b>
											<span>Total Paid Amount: {{final_totals?.total_paid}}</span> &nbsp;&nbsp;
										</b>
									</div> -->
								  </div>
								  <div class="col-12 my-1">
									<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Billing
										Guideline</button>
								  </div>
								  
                            </div>
                        </fieldset>
                        <!-- <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                            [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                            [offset]="page.pageNumber" (page)="pageChangeData($event)">
                            <ngx-datatable-column name="Name" prop="name" [width]="300">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="d-flex align-items-center">
										<div class="avatar mr-1 ml-0 bg-primary">
											<div class="avatar-content">
											  {{ row?.job?.name | shortName }}
											</div>
										</div>
                                        <div class="cell-line-height cursor-pointer" (click)="openModalReports(reportsModal,row?.job?._id,isHourlyList)">
                                            <p class="font-medium-1 line-height-1 mb-0">
                                                {{ row?.job?.name }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Type" prop="type" [width]="20">
								<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
									{{row?.outsourcingtransactions[0]?.type}}
								</ng-template>
							</ngx-datatable-column>
							
							<ngx-datatable-column name="Actions" [width]="10"
							*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
							<ng-template let-row="row" ngx-datatable-cell-template>
							  <i class="ft-trash-2 cursor-pointer danger"
								(click)="Delete(row._id)"></i>
							</ng-template>
						  </ngx-datatable-column>
                        </ngx-datatable> -->

						<div class="datatable-container">
						<ngx-datatable class="bootstrap core-bootstrap" [rows]="sample_data" [columns]="columns" [headerHeight]="50" [count]="page.totalPages"
							[rowClass]="rowClass" [footerHeight]="50" [rowHeight]="'auto'" [scrollbarH]="true">
						
							<!-- Project Name Column -->
							<ngx-datatable-column name="Project Name" [width]="'20%'">
								<ng-template ngx-datatable-cell-template let-row="row" >
									<div class="project-details">
										<div class="project-name" [ngClass]="{'text-danger': row.pendingHours > 15 || row.OnAlert=='Yes'}" (click)="openModalReports(reportsModal,row)">
											<span placement="right" [ngbTooltip]="row.Notes">{{ row.projectName }}</span>
										</div>
										<div class="channel-name my-1">
											<span class="bg-light-info badge mx-1 my-1" placement="right" ngbTooltip="channel">{{ row.channelName }}</span>
											<span class="bg-light-info badge mx-1 my-1" placement="right" ngbTooltip="farming by">{{ row?.FarmingBy }}</span>
										</div>
										<p placement="right" ngbTooltip="Last Modified">{{row.lastModifiedDate | date:'mediumDate'}}</p>
									</div>
								</ng-template>
							</ngx-datatable-column>
						
							<!-- Date Column -->
							<ngx-datatable-column name="Date">
								<ng-template ngx-datatable-cell-template let-row="row">
									<p>{{ row.paymentDate | date:'mediumDate' }}</p>
									<p class="bg-light-secondary badge my-1">{{ row.lastModifiedBy }}</p>
								</ng-template>
							</ngx-datatable-column>
						
							<!-- Completed Hours Column -->
							<ngx-datatable-column name="Completed Hours" prop="completedHours"></ngx-datatable-column>
						
							<!-- Pending Hours Column -->
							<ngx-datatable-column name="Pending Hours" prop="pendingHours">
								<ng-template ngx-datatable-cell-template let-row="row">
									<p *ngIf="row.pendingHours > 0" class="bg-light-danger badge my-1">{{ row.pendingHours }}</p>
									<p class="my-1" *ngIf="row.pendingHours == 0">{{ row.pendingHours }}</p>
									<p class="my-1" *ngIf="row.pendingHours == '-'">{{ row.pendingHours }}</p>
								</ng-template>
							</ngx-datatable-column>
						
							<!-- Amount Column -->
							<ngx-datatable-column name="Amount" prop="totalAmount">
								<ng-template ngx-datatable-cell-template let-row="row">
									<p class="text-success font-weight-bold my-1">{{ row.totalAmount | currency:'USD':'symbol':'1.0-0' }}</p>
								</ng-template>
							</ngx-datatable-column>
						
							<!-- Limit Column -->
							<ngx-datatable-column name="Limit" prop="totalLimit"></ngx-datatable-column>
						
							<!-- Type Column -->
							<!-- <ngx-datatable-column name="Type" prop="project_type"></ngx-datatable-column> -->
						
							<!-- Status Column -->
							<ngx-datatable-column name="Status" prop="paymentStatus">
								<ng-template ngx-datatable-cell-template let-row="row">
								
									<!-- <p class="bg-light-warn badge my-1" *ngIf="row.paymentStatus === 'due'">{{ row.paymentStatus }}</p>
									<p class="bg-light-success badge my-1" *ngIf="row.paymentStatus === 'received'">{{ row.paymentStatus }}</p> -->
									<p>{{row.project_type | titlecase}}</p>
									<p [matMenuTriggerFor]="status">
										<span  *ngIf="row.paymentStatus === 'due'"
											[ngClass]="{'bg-light-danger badge my-1 cursor-pointer':row.paymentStatus === 'due'}">
											{{row.paymentStatus | titlecase}}
										</span>
										<span *ngIf="row.paymentStatus === 'received'"
											[ngClass]="{'bg-light-success badge my-1 cursor-pointer':row.paymentStatus === 'received'}">
											{{row.paymentStatus | titlecase}}
										</span>
									</p>
									<mat-menu #status="matMenu">
										<div *ngFor="let status of pamentStatusList">
											<button mat-menu-item *ngIf="status?.name !== row.paymentStatus"
												(click)="updateStatus(row,status.name,'table1')">
												<span>
													<span *ngIf="status.name === 'due'" [ngClass]="{'bg-light-danger badge my-1 cursor-pointer':status.name === 'due'}">
														{{status.name | titlecase}}
													</span>
													<span *ngIf="status.name === 'received'"
														[ngClass]="{'bg-light-success badge my-1 cursor-pointer':status.name === 'received'}">
														{{status.name | titlecase}}
													</span>
												</span>
											</button>
										</div>
									</mat-menu>

								</ng-template>
							</ngx-datatable-column>
						
							<!-- Actions Column -->
							<ngx-datatable-column name="Actions"
								*ngIf="user_role.roles === 'admin' || user_role.roles === 'employee' || user_role.roles === 'extractor'">
								<ng-template ngx-datatable-cell-template let-row="row" >
									<div [hidden]="(row.projectName =='Week Total') || (row.week =='Month Total')" >
											<i class="ft-edit cursor-pointer primary mx-1" (click)="openAddModal(myModalPayment,'update payment1',row)"></i>
											<i class="ft-trash-2 cursor-pointer danger mx-1" (click)="Delete(row)"></i>
									</div>
								
								</ng-template>
							</ngx-datatable-column>
						
						</ngx-datatable>
</div>
						


                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>

<!-- --------- -->


<div>
	<ng-template #myModalPayment let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="!row_id">Add</h4>
			<h4 class="modal-title" *ngIf="row_id">Update {{reports_modal?.job_id?.name}}</h4>

			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<label>Project Name</label>
					<ng-select [items]="contarct_List" bindLabel="name" bindValue="_id" placeholder="Select Name" [(ngModel)]="selected_contract" [ngModelOptions]="{ standalone: true }" (change)="getNameId($event)">
					</ng-select>
				</div>
				<div class="form-group" *ngIf="!isFixed">
					<label>Billable Hours</label>
					<input type="number" class="form-control" [(ngModel)]="reports_modal.limit" [ngModelOptions]="{ standalone: true }"
						placeholder="Enter Billable Hours">
				</div>
				<div class="form-group" *ngIf="!isFixed">
					<label>Contract Limit</label>
					<input type="number" class="form-control" [(ngModel)]="reports_modal.hours" [ngModelOptions]="{ standalone: true }" placeholder="Enter Hours">
					<div *ngIf="reports_modal.hours>reports_modal.limit">
						<span class="text-danger">Contract Limit should be less than billable hours!</span>
					</div>
				</div>
				<div class="form-group" *ngIf="!isFixed">
					<label>Rate</label>
					<input type="number" class="form-control" [(ngModel)]="reports_modal.rate" [ngModelOptions]="{ standalone: true }" placeholder="Enter Rate">
				</div>
				
				<div class="form-group" *ngIf="!isFixed">
					<label>Completed</label>
					<input type="number" class="form-control" [(ngModel)]="reports_modal.completed" [ngModelOptions]="{ standalone: true }" placeholder="Enter Completed">
				</div>
				<div class="form-group">
					<label>Type</label>
					<ng-select [items]="type_List" bindLabel="name" bindValue="id" placeholder="Select type"
						[(ngModel)]="selected_type" [ngModelOptions]="{ standalone: true }">
					</ng-select>
				</div>
				<div class="form-group">
					<label>Payment Method</label>
					<ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id" placeholder="Select Payment Mode"
						[(ngModel)]="selectedPaymentMode" [ngModelOptions]="{ standalone: true }" (change)="getPaymentModeId($event)">
					</ng-select>
				</div>
				<div class="form-group">
					<label>Alert</label>
					<ng-select [items]="onAlert_List" bindLabel="name" bindValue="name" placeholder="Select Alert"
						[(ngModel)]="selectedOnAlert" [ngModelOptions]="{ standalone: true }">
					</ng-select>
				</div>
				<div class="form-group">
					<label>Payment Status</label>
					<ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name" placeholder="Select Status"
						[(ngModel)]="selectedPaymentStatus" [ngModelOptions]="{ standalone: true }">
					</ng-select>
				</div>
				<div class="form-group">
					<label>Farming<span class="required_field">*</span></label>
					<ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Farming"
						[(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }"
						(change)="getFarmId($event,'form')" #farmingBy="ngModel">
					</ng-select>
				</div>
				<div class="form-group" *ngIf="isFixed">
					<label>Amount</label>
					<input type="number" class="form-control" [(ngModel)]="reports_modal.fixed_amount" [ngModelOptions]="{ standalone: true }"
						placeholder="Enter Amount">
				</div>
				<div class="form-group">
					<label>Payment Date</label>
					<input type="date" class="form-control" [(ngModel)]="reports_modal.payment_date"
						[ngModelOptions]="{standalone: true}" [ngModel]="reports_modal.payment_date | date: 'yyyy-MM-dd'">
				</div>
				<div class="form-group" *ngIf="isFixed">
					<label>Next Payment Date</label>
					<input type="date" class="form-control" [(ngModel)]="reports_modal.next_paymentdate"
						[ngModelOptions]="{standalone: true}" [ngModel]="reports_modal.next_paymentdate | date: 'yyyy-MM-dd'">
				</div>
				<div class="form-group">
					<label>Notes</label>
					<input type="text" class="form-control" [(ngModel)]="reports_modal.notes"
						[ngModelOptions]="{standalone: true}" placeholder="Enter Notes">
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<input type="text" class="form-control" [(ngModel)]="reports_modal.admin_notes"
						[ngModelOptions]="{standalone: true}" placeholder="Enter Admin Notes">
				</div>
			</form>

		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" [disabled]="reports_modal.hours>reports_modal.limit" (click)="addPayment()">Submit</button>
		</div>
	</ng-template>
</div>

<!-- Reports -->

<div>
	<ng-template #reportsModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title"><h4>{{current_data[0]?.job_id?.name}}</h4></h4>

			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="d-flex justify-content-between my-2">
				<div>
					
					<span class="bg-light-primary badge mx-1">Project Budget:  {{current_data[0]?.project_budget | currency:'USD':'symbol':'1.0-0'}}</span>
					<span *ngIf="!isHourlyList" class="bg-light-success badge mx-1">Paid Amount:  {{current_data[0]?.TotalAmount | currency:'USD':'symbol':'1.0-0'}}</span>
					<span *ngIf="isHourlyList" class="bg-light-success badge mx-1">Paid Amount: {{current_data[0]?.total_paid | currency:'USD':'symbol':'1.0-0'}}</span>
					<span class="bg-light-danger badge mx-1">Pending Amount:
						{{current_data[0]?.TotalPendingAmount | currency:'USD':'symbol':'1.0-0'}}</span>
					<span class="bg-light-secondary badge mx-1">Farming By:
						{{current_data[0]?.farming_by[0]?.name }}</span>
				</div>
				<div>
					<button class="btn btn-primary" (click)="openAddModal(myModalPayment,'add project payment',current_data[0])">Add</button>
				</div>
			</div>
			<div class="container">
				<table class="table mb-0">
					<thead>
						<tr>
							<th *ngIf="!isHourlyList">Paid Amount</th>
							<th>Date</th>
							<th *ngIf="!isHourlyList">Hours</th>
							<th *ngIf="!isHourlyList">Limit</th>
							<th *ngIf="!isHourlyList">Rate</th>
							<th *ngIf="!isHourlyList">Completed</th>
							<th *ngIf="!isHourlyList">Pending</th>
							<th *ngIf="isHourlyList">Amount</th>
							<th>Status</th>
							<th *ngIf="isHourlyList">Method</th>
							<th *ngIf="isHourlyList">Next Payment Date</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of current_data ; let i=index">
				
							<td *ngIf="!isHourlyList">
								<span>{{ item?.PaidAmount | currency:'USD':'symbol':'1.0-0' }}</span>
							</td>
							<td>
								<span class="date">{{ item?.payment_date | date :'mediumDate' }}</span>
							</td>
							<td *ngIf="!isHourlyList">
								<span>{{ item?.hours }}</span>
							</td>
							<td *ngIf="!isHourlyList">
								<span>{{ item?.limit}}</span>
							</td>
							<td *ngIf="!isHourlyList">
								<span>{{ item?.rate}}</span>
							</td>
							<td *ngIf="!isHourlyList">
								<span class="badge bg-light-success">{{item.completed}}</span>
							</td>
							<td *ngIf="!isHourlyList">
								<span *ngIf="item?.pending>15" class="badge bg-light-danger">{{item?.pending}}</span>
								<span *ngIf="item?.pending <15 ">{{item?.pending}}</span>
							</td>
							<td *ngIf="isHourlyList">
								{{item.fixed_amount | currency:'USD':'symbol':'1.0-0'}}
							</td>
							<td>
								<span *ngIf="item?.payment_status =='due'" class="badge bg-light-danger  my-1 collapsible-button" (click)="toggleCollapse(i)">{{ item?.payment_status | titlecase }}</span>
								<span *ngIf="item?.payment_status =='received'"
									class="badge bg-light-success  my-1 collapsible-button" (click)="toggleCollapse(i)">{{ item?.payment_status | titlecase }}</span>

									
									
									<div class="collapsible-content" *ngIf="isCollapsed[i]">
										<div *ngFor="let status of pamentStatusList" >
											<span  *ngIf="status?.name !== item?.payment_status" (click)="updateStatus(item,status.name,'table2')">
												<span *ngIf="status?.name =='due'" class="badge bg-light-danger cursor-pointer  my-1">{{ status?.name | titlecase }}</span>
												<span *ngIf="status?.name =='received'" class="badge bg-light-success  cursor-pointer my-1">{{ status?.name | titlecase }}</span>
											</span>
										</div>
									</div>
								<br>				
							</td>
							<td *ngIf="isHourlyList"><span class="badge bg-light-secondary my-1">{{ item?.mode[0]?.displayname }}</span></td>
							<td *ngIf="isHourlyList">
								<span class="date">{{ item?.next_paymentdate | date :'mediumDate' }}</span>
							</td>
							<td>
								<i class="ft-edit text-primary cursor-pointer mr-2" (click)="openAddModal(myModalPayment,'update payment',item)"></i>
								<i class="ft-trash-2 cursor-pointer danger" (click)="ConfirmColor(item._id)"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

		</div>
		
	</ng-template>
</div>